var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4126 4.30977L6.59075 9.80352L4.55325 7.8129C3.72513 6.96602 2.44075 8.22227 3.26575 9.06915L5.997 11.7379C6.16263 11.9004 6.39075 12.0004 6.64075 12.0004C6.91575 12.0004 7.16263 11.8785 7.33138 11.6879L12.7939 5.46602C13.522 4.59414 12.1408 3.43789 11.4126 4.30977Z","fill":"#212123"}));
}

Checkmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
